import type { CustomAttribute } from '@/types';
import type { PaginateAttributes } from '@/ui/LoadMore';
import { LoadMore } from '@/ui/LoadMore/LoadMore';

import NumberedPagination from './NumberedPagination';

interface PaginationProps {
  type: 'loadMore' | 'infiniteScroll' | 'numberedPagination';
  onLoadMore?: () => void;
  attributes: PaginateAttributes;
  customAttributes?: CustomAttribute;
  isBusy?: boolean;
  isLive?: boolean;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

const Pagination = ({
  type,
  onLoadMore,
  attributes,
  isLive = false,
  isBusy = false,
  customAttributes,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}: PaginationProps) => {
  switch (type) {
    case 'loadMore':
    case 'infiniteScroll':
      return (
        <LoadMore
          onClick={onLoadMore!}
          attributes={attributes}
          isBusy={isBusy}
          isLive={isLive}
          customAttributes={customAttributes}
        />
      );
    case 'numberedPagination':
      return (
        <NumberedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange!}
          attributes={attributes}
          customAttributes={customAttributes}
          isLive={isLive}
        />
      );
  }
};

export default Pagination;
